export const DOCUMENT_CONTROLS_TAB = 'DOCUMENT_CONTROLS_TAB';
export const DOCUMENT_CONTROLS_CREATE = 'DOCUMENT_CONTROLS_CREATE';
export const DOCUMENT_CLEAR_CREATE = 'DOCUMENT_CLEAR_CREATE';
export const DOCUMENT_CONTROLS_DELETE = 'DOCUMENT_CONTROLS_DELETE';